import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Page } from "../components/Layout";
import CustomerSelect from "../components/CustomerSelect";
import RecordingDrawer from "../components/RecordingDrawer";
import { api, notifyErr, fmtDate, fmtSec } from "../lib/api";
import { useCustomers } from "../lib/hooks";
import { CategoryBadge, ReviewBadge, Tone, CATEGORY_LABEL } from "../lib/labels";

function Filter({ value, onChange, items, testid, placeholder }) {
  return (
    <Select value={value || "__all"} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
      <SelectTrigger className="h-8 w-56 rounded-sm" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent><SelectItem value="__all">{placeholder}</SelectItem>{items.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export default function Interessati() {
  const [searchParams] = useSearchParams();
  const initialCategory = searchParams.get("category") || "";
  const { customers } = useCustomers();
  const [cid, setCid] = useState("");
  const [rs, setRs] = useState("");
  const [cat, setCat] = useState(
    Object.prototype.hasOwnProperty.call(CATEGORY_LABEL, initialCategory)
      ? initialCategory
      : ""
  );
  const [scope, setScope] = useState(
    searchParams.get("scope") === "all" ? "all" : "opportunity"
  );
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => {
    const p = new URLSearchParams({ scope });
    if (cid) p.set("customer_id", cid);
    if (rs) p.set("review_status", rs);
    if (cat) p.set("category", cat);
    api.get(`/opportunities?${p}`).then((r) => setRows(r.data)).catch(notifyErr);
  };
  useEffect(load, [cid, rs, cat, scope]); // eslint-disable-line
  return (
    <Page title="Clienti Interessati" subtitle="Opportunità individuate dall'AI locale. Solo quelle approvate e idonee (ultimi 5 giorni, senza richiesta di non contatto) entrano nel report di consegna." testid="interessati-page"
      actions={<CustomerSelect customers={customers} value={cid} onChange={setCid} allowAll testid="interessati-customer-select" />}>
      <div className="flex gap-2 mb-3 flex-wrap">
        <Filter value={rs} onChange={setRs} testid="filter-review-status" placeholder="Tutti gli stati revisione" items={[["pending", "Da verificare"], ["needs_review", "Da rivedere"], ["approved", "Approvati"], ["rejected", "Rifiutati"]]} />
        <Filter value={cat} onChange={setCat} testid="filter-category" placeholder="Tutte le classificazioni" items={Object.entries(CATEGORY_LABEL)} />
        <Filter value={scope === "all" ? "all" : ""} onChange={(v) => setScope(v ? "all" : "opportunity")} testid="filter-scope" placeholder="Solo opportunità" items={[["all", "Tutte le analisi"]]} />
        <span className="text-xs text-neutral-500 self-center" data-testid="opportunities-count">{rows.length} risultati</span>
      </div>
      <div className="bg-white border rounded-sm overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Telefono</TableHead><TableHead>Cliente</TableHead><TableHead>Campagna</TableHead><TableHead>Agente</TableHead><TableHead>Esito orig.</TableHead><TableHead>Data</TableHead><TableHead className="text-right">Durata</TableHead><TableHead>Classificazione AI</TableHead><TableHead className="w-80">Spiegazione</TableHead><TableHead>Affid.</TableHead><TableHead>Verifica</TableHead><TableHead>Idoneo</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map(({ analysis: a, recording: r, customer_name, eligible }) => (
              <TableRow key={a.id} className="row-hover text-xs cursor-pointer" onClick={() => setOpen(r.id)} data-testid={`opportunity-row-${a.id}`}>
                <TableCell className="font-mono font-medium">{r.phone_number || "—"}</TableCell><TableCell>{customer_name}</TableCell>
                <TableCell className="font-mono">{r.campaign}</TableCell><TableCell>{r.agent}</TableCell><TableCell className="font-mono">{a.original_disposition}</TableCell>
                <TableCell className="whitespace-nowrap">{fmtDate(r.call_date)}</TableCell><TableCell className="text-right tabular-nums">{fmtSec(r.duration_sec)}</TableCell>
                <TableCell><CategoryBadge code={a.category} /></TableCell>
                <TableCell className="max-w-xs"><div className="line-clamp-2">{a.explanation}</div>{a.evidence?.[0] && <div className="text-neutral-500 italic line-clamp-1">“{a.evidence[0].text}”</div>}</TableCell>
                <TableCell className="tabular-nums">{Math.round((a.confidence || 0) * 100)}%</TableCell>
                <TableCell><ReviewBadge status={a.review_status} testid={`opportunity-review-${a.id}`} /></TableCell>
                <TableCell>{eligible ? <Tone tone="green">Sì</Tone> : <Tone tone="red">Scaduto</Tone>}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={12} className="text-center text-neutral-500 py-10">Nessuna opportunità con questi filtri.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <RecordingDrawer recordingId={open} onClose={() => setOpen(null)} onChanged={load} />
    </Page>
  );
}
